<template>
    <div class="previewAttachment">
        <div class="attachmentTitle" v-if="imgArr.length">
            <span>{{ updateUserName ? '上传人：' + updateUserName : '' }}</span>
            <div style="padding-left: 70px">
                {{ carouselIndex + 1 + ' / ' + imgArr.length }}
            </div>
            <span>{{ updateTime ? '上传时间：' + updateTime : '' }}</span>
        </div>
        <div v-else class="no-data">暂无附件信息</div>
        <div class="attachmentLeft" v-show="imgArr.length">
            <div style="height: 340px">
                <ul id="viewers" style="display: none">
                    <li v-for="(item, index) in imgArr" :key="index">
                        <img :src="item.path" />
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

export default {
    name: 'imgShowDialog',
    props: {
        title: {
            type: String,
            default () {
                return '';
            }
        },
        attachmentShow: {
            type: Boolean,
            default () {
                return false;
            }
        },
        imgArr: {
            type: Array,
            default () {
                return [];
            }
        },
        fileIndex: {
            type: Number,
            default () {
                return 0;
            }
        }
    },
    data () {
        return {
            viewer: {},
            carouselIndex: 0, // 轮播图当前的索引
            updateUserName: '',
            updateTime: ''
        };
    },
    mounted () {
        this.$nextTick(() => {
            this.updateViewer();
        });
    },
    methods: {
        updateViewer () {
            this.carouselIndex = this.fileIndex;
            this.updateInfo();
            this.$nextTick(() => {
                this.initViewer();
            });
        },
        updateInfo () {
            this.updateTime = this.imgArr[this.carouselIndex].createTime;
            this.updateUserName = this.imgArr[this.carouselIndex].createUserName;
        },
        initViewer () {
            if (this.imgArr.length > 0) {
                const barOptions = { show: true, size: 'default' };
                this.viewer = new Viewer(document.getElementById('viewers'), {
                    title: false,
                    inline: true,
                    navbar: true,
                    focus: false,
                    backdrop: true, // 透明背景色
                    zoomOnWheel: true, // 滚动缩放
                    toolbar: {
                        zoomIn: barOptions,
                        zoomOut: barOptions,
                        oneToOne: barOptions,
                        reset: barOptions,
                        prev: {
                            show: true,
                            size: 'default',
                            click: () => {
                                if (this.carouselIndex === 0) {
                                    return this.$message.warning('当前图片是第一张');
                                } else {
                                    this.carouselIndex -= 1;
                                    this.viewer.prev(true);
                                }
                            }
                        },
                        play: barOptions,
                        next: {
                            show: true,
                            size: 'default',
                            click: () => {
                                if (this.carouselIndex === this.imgArr.length - 1) {
                                    return this.$message.warning('当前图片是最后一张');
                                } else {
                                    this.carouselIndex += 1;
                                    this.viewer.next(true);
                                }
                            }
                        },
                        rotateLeft: barOptions,
                        rotateRight: barOptions,
                        flipHorizontal: barOptions,
                        flipVertical: barOptions
                    },
                    viewed: (data) => { // 图片加载完成时回调
                        this.carouselIndex = data.detail.index;
                        this.updateInfo();
                    }
                });
                this.viewer.view(this.fileIndex);
            }
        }
    },
    beforeDestroy () {
        this.viewer.destroy();
    }
};
</script>

<style lang="less" scoped>
.previewAttachment {
    .attachmentTitle {
        margin: 10px 0;
        display: flex;
        justify-content: space-between;
    }

    .attachmentLeft {
        position: relative;

        .loadingBox {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: #fff;
            z-index: 1000;

            .progress {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
        }

        .carousel {
            text-align: center;

            .receiveImgs {
                height: 100%;
            }
        }
    }

    .no-data {
        text-align: center;
    }
}
</style>
